<div class="dashboard-container">
  <div class="main-header">
    <div class="header-content">
      <div class="logo-area">
        <div class="logo-circle">
          <mat-icon fontSet="material-symbols-outlined">table_chart_view</mat-icon>
        </div>
        <div class="text-content">
          <h2>Desempenho Acadêmico</h2>
          <p class="subtitle">Acompanhe o desenvolvimento acadêmico do seu filho</p>
        </div>
      </div>
    </div>
  </div>

  <div class="main-content">
    <div class="controls-section">
      <app-aluno-selector
        [alunos]="alunos"
        [alunoSelecionado]="alunoSelecionado"
        (alunoSelecionado$)="selecionarAluno($event)">
      </app-aluno-selector>

      <div class="ano-selector">
        <label for="ano-select">Ano Letivo:</label>
        <select id="ano-select" [(ngModel)]="anoSelecionado" (ngModelChange)="onAnoChange()">
          <option *ngFor="let ano of anosLetivos" [ngValue]="ano">{{ getDescricaoAnoTurma(ano) }}</option>
        </select>
      </div>
    </div>

    <div class="aluno-info-card" *ngIf="alunoSelecionado">
      <div class="aluno-foto-grande">
        <mat-icon>person</mat-icon>
      </div>
      <div class="aluno-detalhes">
        <h2>{{ alunoSelecionado.nome }}</h2>
        <p>{{ getTurmaAtual() }}</p>
      </div>
    </div>

    <div class="content-tabs">
      <button
        class="tab-button"
        [class.active]="abaAtiva === 'boletim'"
        (click)="selecionarAba('boletim')">
        <mat-icon>assessment</mat-icon>
        Avaliações e Faltas
      </button>
      <button
        class="tab-button"
        [class.active]="abaAtiva === 'relatorio'"
        (click)="selecionarAba('relatorio')">
        <mat-icon>description</mat-icon>
        Avaliações Individuais
      </button>
    </div>

    <div class="content-area">
      <div *ngIf="abaAtiva === 'boletim'">
        <app-boletim
          [boletim]="boletim"
          [carregando]="carregandoBoletim"
          [alunoId]="alunoSelecionado?.id"
          [turmaId]="anoSelecionado?.turmaId">
        </app-boletim>
      </div>

      <div *ngIf="abaAtiva === 'relatorio'">
        <app-relatorio-geral
          [disciplinasComAvaliacoes]="relatorioGeral || []"
          [carregando]="carregandoRelatorio"
          [alunoId]="alunoSelecionado?.id || null"
          [anoLetivoId]="anoSelecionado?.id || null">
        </app-relatorio-geral>
      </div>
    </div>
  </div>
</div>
